export interface Fund8TreeNode {
  level: number
  nftId: number
  qualified: boolean
  registered: boolean
  teamSize: number
}

export interface Fund8HomeData {
  masterIB: number | null
  nftId: number | null
  nodes?: readonly Fund8TreeNode[] | null
  sponsor1: number | null
  view: string
  walletCents: number
}

export interface Fund8Tiles {
  lines: string[]
  master: string
  nft: string
  sponsor: string
  wallet: string
}

const TAURO_COMPANIES = ['tauroMarkets', 'tauroMarketsMauritius']

/** Fund8 is a Tauro campaign. Other brands do not ask for the field. */
export const fund8HomeEnabled = (company: string | null | undefined): boolean =>
  company != null && TAURO_COMPANIES.includes(company)

const idText = (value: number | null): string => (value == null ? '—' : String(value))

/**
 * Commission wallet, NFT, sponsor, and master. Null is none.
 * NFT 0 is a member. The tree is only for the network root and a leader.
 */
export const fund8Tiles = (home: Fund8HomeData | null | undefined): Fund8Tiles | null => {
  if (home == null || home.view === 'hidden') return null
  const tree = home.view === 'full' || home.view === 'downline'
  const nodes = home.nodes ?? []
  return {
    lines: tree
      ? nodes.map(
          (node) =>
            `NFT ${node.nftId} · level ${node.level} · ${node.registered ? 'registered' : 'not registered'} · ${
              node.qualified ? 'qualified' : 'not qualified'
            } · team ${node.teamSize}`,
        )
      : [],
    master: idText(home.masterIB),
    nft: idText(home.nftId),
    sponsor: idText(home.sponsor1),
    wallet: (home.walletCents / 100).toFixed(2),
  }
}
